<template>
    <div class="bg jgList">
        <div class="jgListTit fix">
            <span class="fl">共搜索到 <i class="verdan red">{{total}}</i> 个机构</span><div class="fr"><strong class="verdanF12">{{params.page}}/{{totalPage}}</strong>
            <span class="fix">
                <a :href="'/mechanismsearch?area_name='+this.$route.query.area_name+'&province='+this.$route.query.province+'&class_name='+this.$route.query.class_name+'&letter='+this.$route.query.letter+'&page=1'+'&page_size=10'+'&name='+this.$route.query.name" class="b1"></a>
                <a :href="'/mechanismsearch?area_name='+this.$route.query.area_name+'&province='+this.$route.query.province+'&class_name='+this.$route.query.class_name+'&letter='+this.$route.query.letter+'&page='+ prevPage+'&page_size=10'+'&name='+this.$route.query.name" class="a1"></a>
                <a :href="'/mechanismsearch?area_name='+this.$route.query.area_name+'&province='+this.$route.query.province+'&class_name='+this.$route.query.class_name+'&letter='+this.$route.query.letter+'&page='+ nextPage+'&page_size=10'+'&name='+this.$route.query.name" class="a2"></a>
                <a :href="'/mechanismsearch?area_name='+this.$route.query.area_name+'&province='+this.$route.query.province+'&class_name='+this.$route.query.class_name+'&letter='+this.$route.query.letter+'&page='+ totalPage+'&page_size=10'+'&name='+this.$route.query.name" class="b2"></a>
            </span>
        </div>
        </div>
        <div class="jgListBox" v-if="orgList.length">
            <dl v-for="(item,i) in orgList" :key="i">
                <dt>
                    <template v-if="item.name=='中国嘉德'">
                        <a href="https://www.cguardian.com" target="_blank"><img :src="item.logo_pic" :alt="item.name" @error="headError"></a>
                            </template>
                    <template v-else-if="item.organ_zone == ''">
                        <a :href="'/org_detail/'+item.organ_code" target="_blank"><img :src="item.logo_pic" :alt="item.name" @error="headError"></a>
                    </template>
                    <template v-else>
                        <a :href="'/'+item.organ_zone" target="_blank"><img :src="item.logo_pic" :alt="item.name" @error="headError"></a>
                    </template>

                </dt>
                <dd>
                    <div class="jgTit">
                        <strong>
                            <template v-if="item.name=='中国嘉德'">
                                                <a :href='`https://www.cguardian.com`' target="_blank">{{item.name}}</a>
                            </template>
                            <template v-else-if="item.organ_zone == ''">
                                <a :href="'/org_detail/'+item.organ_code" target="_blank">{{item.name}}</a>
                            </template>
                            <template v-else>
                                <a :href="'/'+item.organ_zone" target="_blank">{{item.name}}</a>
                            </template>
<!--                            <template v-if="item.attentioned == 0">-->
<!--                                <a class="focusBtn" href="javascript:void(0);" @click="addmark(item.organ_code,$event);" id="mark_focusJG0184"><b></b>加关注</a>-->
<!--                            </template>-->
                        </strong>
                        <p>

                            <span>所在地：{{item.city}}</span><br>
                            <span>信用认证：{{totalrz(item)}}</span>
                        </p>
                    </div>
                </dd>
            </dl>
        </div>
        <!--翻页begin-->
        <EmptyPage v-else></EmptyPage>
        <div class="paging">
            <el-pagination
                background
                :page-size="1"
                layout=" prev, pager, next"
                :total="totalPage > 1000 ? 1000 : totalPage"
                :current-page.sync="jumpVal"
                :prev-text="'&lt; 上一页'"
                :next-text	="'下一页 &gt;'"
                @current-change="jumpToPage"
                @prev-click="jumpToPage"
                @next-click="jumpToPage"
            >
            </el-pagination>
            <span class="total">共有{{totalPage}}页</span>
            <div class="jumpBox">
                到第
                <input type="text" class="inputJump" v-model="jumpVal" @change="changeNum(jumpVal)" v-on:keyup.13="jumpTo">
                页
            </div>
        </div>
        <!--翻页end-->
    </div>
</template>

<script>
import $ from 'jquery'
import {getSearchOrg} from "@/api/brand";
import EmptyPage from "@/components/common/emptyPage";
export default {
    name: "OrganList",
    data(){
        return{
            jumpVal:this.$route.query.page || 1,
            orgList:[],
            params:{
                area_name:this.$route.query.area_name && this.$route.query.area_name == '全部' ? '' : this.$route.query.area_name,
                province:this.$route.query.province && this.$route.query.province == '全部' ? '' : this.$route.query.province,
                class_name:this.$route.query.class_name && this.$route.query.class_name == '综合' ? '' : this.$route.query.class_name,
                letter:this.$route.query.letter && this.$route.query.letter == '全部' ? '' : this.$route.query.letter,
                page:this.$route.query.page || 1,
                page_size:10,
                name:this.$route.query.name || ''
            },
            totalPage:0,
            total:0,
            nextPage:0,
            prevPage:0
        }
    },
    computed:{

    },
    mounted() {
        this.getSearchOrg()
    },
    methods:{
        headError(e) {
            e.target.src = require("../../../assets/imgs/detail_error.jpg");
            console.log('加载失败',e);
        },
        totalrz(item){
            return item.IsBeian+item.IsStandard+item.IsZhongpai+item.attentioned
        },
        changeNum() {
            this.jumpVal =
                Number(this.jumpVal) < 0 || !Number(this.jumpVal)
                    ? 0
                    : this.jumpVal > this.totalPage ? this.totalPage : this.jumpVal;
        },
        jumpToPage(val){
            this.params.page = val;
            this.$router.push({
                name:'mechanismsearch',
                query:this.params
            })
        },
        jumpTo(){
            this.params.page = this.jumpVal;
            this.$router.push({
                name:'mechanismsearch',
                query:this.params
            })
        },
        getSearchOrg(){
            getSearchOrg(this.params).then((res) => {
                this.total = res.data.total
                this.totalPage = Math.ceil(this.total/this.params.page_size)
                this.orgList = res.data.list
                this.nextPage = this.$route.query.page ? this.$route.query.page < this.totalPage ? parseInt(this.$route.query.page)+1 : this.$route.query.page : 2
                this.prevPage = this.$route.query.page ? this.$route.query.page==1 ? 1 : parseInt(this.$route.query.page)-1 : 1
            })
        },
        getCookie:function (name) {
            var arr;
            var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if(document.cookie.match(reg)) {
                arr = document.cookie.match(reg);
                return arr[2];
            }else {
                return null;
            }
        },
        addmark(code,e){
            var userid = this.getCookie("_at_pt_0_");
            let $target = $(e.target)
            var url=window.location.href;
            console.log(userid)
            if(userid){
                $.ajax({
                    "type" : "post",
                    "url" : "//auction.artron.net/auctionzone/memberCollect.php",
                    "data" : {
                        "OrganCode" : code,
                        "userid" :userid,
                        "type" : 1
                    },
                    "success" : function(data){
                        if(data==1){
                            $target.addClass('focused').html('<i></i>已关注')
                            return false;
                        }else if(data == '122100') {
                            alert('温馨提示：普通会员最多关注100个拍卖机构，请在删除已关注的拍卖机构后重新关注');
                            return false;
                        } else {
                            alert('关注失败，请刷新重试');
                            return false;
                        }

                    }
                });
            }else{
                if(confirm("请登录之后再添加关注！")){
                    window.location.href="//passport.artron.net/login?appId=2&redirect="+ encodeURIComponent(url);
                }
            }
        }
    },
    components:{
        EmptyPage
    }
}
</script>

<style scoped lang="scss">
.jgList {
    padding: 10px 10px 40px 10px;
}
.jgList .jgListTit {
    font-size: 14px;
    margin-bottom: 6px;
}
.jgListTit .fr strong, .jgListTit .fr span {
    display: block;
    float: left;
}
.jgListTit .fr strong {
    height: 20px;
    line-height: 20px;
    margin-right: 9px;
}
.jgListTit .fr span a {
    float: left;
    display: block;
    width: 20px;
    height: 20px;
    background: url(../../../assets/imgs/old/but.png) no-repeat;
    margin-left: 1px;
}
.jgListTit .fr span a.a1 {
    background-position: left -60px;
}
.jgListTit .fr span a.a2 {
    background-position: left -90px;
}
.jgListTit .fr span a.b1 {
    background-position: left top;
}
.jgListTit .fr span a.b2 {
    background-position: left -30px;
}
.jgList .jgListBox {
    overflow: hidden;
    background: #fff;
}
.jgListBox dl {
    float: left;
    padding: 20px;
    width: 480px;
    background:url(../../../assets/imgs/old/pLine.gif) repeat-x left bottom;
}
.jgListBox dl:nth-child(2n){
    margin-right: 0;
}
.jgListBox dl dt {
    float: left;
    width: 180px;
    height: 100px;
    overflow: hidden;
    a{display:flex;width:100%;height:100%;
        img{width:100%;height: 100%;object-fit: contain;}
    }
}
.jgListBox dl dd {
    float: left;
    width: 250px;
    margin-left: 10px;
    line-height: 20px;
    color: #666;
    margin-top: 10px;
}
.jgListBox dl dd .jgTit strong {
    font-family: "Microsoft Yahei";
    color: #000;
    font-size: 16px;
    margin-right: 10px;
    font-weight: bold;
}
.jgListBox dl dd p {
    margin-top: 5px;
}
.jgListBox .focusBtn {
    display: inline-block;
    font: 12px/26px "Microsoft YaHei";
    height: 26px;
    padding: 0px 6px;
    border: 1px solid #D4D4D4;
    vertical-align: middle;
    border-radius: 2px;
    margin-top: -5px;
    _zoom: 1;
    overflow: hidden;
}
.jgListBox .focusBtn b {
    width: 13px;
    height: 13px;
    float: left;
    margin: 6px 5px 0px 0px;
    background: url(../../../assets/imgs/old/focus.png) 0px 0px no-repeat;
}
.jgListBox  a.focusBtn:hover{ background-color:#0F820C; color:#FEFEFE; border-color:#0F820C;}
.jgListBox a.focusBtn:hover b{ background-position:-38px 0px; cursor:pointer}
.jgListBox .focused b{ background-position:-19px 0px; margin-top:7px;}
.paging{margin-top: 40px;display:flex;justify-content: center;
    /deep/.el-pagination button, /deep/.el-pagination span:not([class*=suffix]){
        height:30px;line-height: 30px;border-top: 3px solid transparent;
    }
    /deep/.el-pagination.is-background .btn-next, /deep/.el-pagination.is-background .btn-prev, /deep/.el-pagination.is-background .el-pager li{
        border-radius: 0;line-height: 38px;height:38px;margin:0;padding:0 14px 0 15px;background-color: transparent;color:#000;
    }
    /deep/.el-pagination.is-background .el-pager li:hover{
        border-top:3px solid #0F820C; line-height:32px; height:35px;
    }
    /deep/.el-pagination.is-background .el-pager li:not(.disabled).active{
        background-color: #0F820C;color:#fff;height:38px;
    }
    /deep/.el-pagination.is-background .btn-next.disabled, /deep/.el-pagination.is-background .btn-next:disabled, /deep/.el-pagination.is-background .btn-prev.disabled, /deep/.el-pagination.is-background .btn-prev:disabled, /deep/.el-pagination.is-background .el-pager li.disabled{color: #999;
        font-size: 12px;
        padding: 0;
        margin:0 10px;
        font-family: 'simsun';}
    /deep/.el-pagination button:hover,/deep/.el-pagination butto:hover span{border-top:3px solid #0F820C;}
    .total{line-height: 43px;font-size: 12px;color:#999;margin-left: 10px;}
    .jumpBox{margin-left: 10px;font-size: 12px;margin-top: 6px;color:#999;}
    .inputJump{
        height: 16px;
        width: 28px;
        text-align: center;
        border: 1px solid #CCC;
        color: #999;
        vertical-align: middle;
        margin: -2px 5px 0 4px;
        font-size: 12px;
        font-family: Verdana;
        display: inline-block;
    }
}

</style>